import { REGION } from './region';

const METRICA_ID = 108596407;

function isAvailable(): boolean {
    return REGION === 'ru' && typeof (window as any).ym === 'function';
}

export function initYandexMetrica() {
    if (REGION !== 'ru') return;

    (function (m: any, e: Document, t: string, r: string, i: string) {
        m[i] = m[i] || function (...args: any[]) { (m[i].a = m[i].a || []).push(args); };
        m[i].l = 1 * +new Date();
        for (let j = 0; j < e.scripts.length; j++) {
            if (e.scripts[j].src === r) return;
        }
        const k = e.createElement(t) as HTMLScriptElement;
        const a = e.getElementsByTagName(t)[0];
        k.async = true;
        k.src = r;
        a.parentNode!.insertBefore(k, a);
    })(window, document, 'script', `https://mc.yandex.ru/metrika/tag.js?id=${METRICA_ID}`, 'ym');

    (window as any).ym(METRICA_ID, 'init', {
        ssr: true,
        webvisor: false,
        clickmap: true,
        ecommerce: 'dataLayer',
        referrer: document.referrer,
        url: window.location.href,
        accurateTrackBounce: true,
        trackLinks: true,
    });
}

export function trackPageView(path: string) {
    if (!isAvailable()) return;
    (window as any).ym(METRICA_ID, 'hit', path);
}

export function reachGoal(goal: string) {
    if (!isAvailable()) return;
    (window as any).ym(METRICA_ID, 'reachGoal', goal);
}
